/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_OkInputs */

const en_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ok`)
};

const fr_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D'accord`)
};

const de_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хорошо`)
};

const es_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De acuerdo`)
};

const zh_cn2_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_subtitle_export_ok = /** @type {(inputs: Subtitle_Export_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "Ok" |
*
* @param {Subtitle_Export_OkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_ok = /** @type {((inputs?: Subtitle_Export_OkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_OkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_ok(inputs)
	if (locale === "de") return de_subtitle_export_ok(inputs)
	if (locale === "it") return it_subtitle_export_ok(inputs)
	if (locale === "ru") return ru_subtitle_export_ok(inputs)
	if (locale === "es") return es_subtitle_export_ok(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_ok(inputs)
	if (locale === "ja") return ja_subtitle_export_ok(inputs)
	if (locale === "hi") return hi_subtitle_export_ok(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_ok(inputs)
	return en_subtitle_export_ok(inputs)
});